import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ConsoleShell } from '@/features/shell/console-shell';
import { ProjectResolver } from '@/features/shell/project-resolver';

/**
 * `/$tenant/experiments` — entrée « Expériences » hors projet : redirige vers
 * `/$tenant/projects/$projectId/experiments` (les expériences sont portées par un projet au contrat).
 */
export const Route = createFileRoute('/$tenant/experiments/')({ component: ExperimentsRoute });

function ExperimentsRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="experiments" crumbs={[{ label: t('nav.items.experiments') }]}>
      <ProjectResolver tenantId={tenant} section="experiments" />
    </ConsoleShell>
  );
}
